import { DateTime } from 'luxon';

export function dateFilter(value: string): string | null {
    if (value == null) {
        return null;
    }

    return DateTime.fromISO(value, { zone: 'UTC' }).toLocal().toLocaleString();
}
export function dateTimeFilter(value: string): string | null {
    if (value == null) {
        return null;
    }

    return DateTime.fromISO(value, { zone: 'UTC' }).toLocal().toLocaleString(DateTime.DATETIME_SHORT);
}
export function currencyFilter(value: string): string | null {
    const num = Number(value);

    if (value == null || isNaN(num)) {
        return '-';
    }

    return num.toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
}
export function bytesToKilobytes(value: string): string | null {
    const num = Number(value);

    if (value == null || isNaN(num)) {
        return null;
    }

    return (num / 1024).toFixed(2) + ' KB';
}
export function bytesToMegabytes(value: string): string | null {
    const num = Number(value);

    if (value == null || isNaN(num)) {
        return null;
    }

    return (num / 1024 / 1024).toFixed(2) + ' MB';
}
